import { useMemo } from 'react'
import { useUserState } from '~/atoms/UserState'

import {
  deriveHotelsPermissionsFromUserRoles,
  getFirstAllowedHotelsRoute,
  hasAnyHotelsAccess,
} from './hotelsPermissions'

export const useHotelsPermissions = () => {
  const { userRoles } = useUserState({ canAutoRefresh: false })

  return useMemo(() => {
    const permissions = deriveHotelsPermissionsFromUserRoles(userRoles)

    return {
      permissions,
      hasAnyAccess: hasAnyHotelsAccess(permissions),
      firstAllowedRoute: getFirstAllowedHotelsRoute(permissions),
    }
  }, [userRoles])
}
